/**
 * The customer's card on this phone: kept when they open it (receipt.com.mx/<slug>/mi/<code>), so the business's
 * catalog can offer paying the order with their saldo. One per business. Browser storage may be unavailable (a
 * private window): then there's just no saldo in the cart.
 */
const key = (slug: string) => `true.card.${slug.toLowerCase()}`;

export const rememberCard = (slug: string, code: string) => {
  try {
    localStorage.setItem(key(slug), code);
  } catch { /* nothing kept */ }
};

export const savedCard = (slug: string): string | null => {
  try {
    return localStorage.getItem(key(slug));
  } catch {
    return null;
  }
};

export const forgetCard = (slug: string) => {
  try {
    localStorage.removeItem(key(slug));
  } catch { /* nothing kept */ }
};
